/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext, useReducer } from 'react';
import * as I from 'immutable';
import type { IntegrationState } from './types';
import IntegrationContext from './IntegrationContext';
import reducer from './reducer';
import Form from './Form';
import Landing from './Landing';
import NavHeader from './NavHeader';

const initState = {
  navMode: 'LANDING',
  // Resource properties
  id: null,
  resourceName: '',
  fields: [],
  url: '',
  name: '',
  showOnResourcePage: false,
};

const mkState: I.RecordFactory<IntegrationState> = I.Record(
  initState,
  'IntegrationState'
);

const BodyShell = () => {
  const intCtx = useContext(IntegrationContext);
  const { navMode } = intCtx.state;

  if (navMode === 'LANDING') {
    return <Landing />;
  } else if (navMode === 'EDIT_INTEGRATION') {
    return <Form />;
  } else if (navMode === 'NEW_INTEGRATION') {
    return <Form />;
  }
  return null;
};

export default (props?: $Shape<IntegrationState> = {}) => {
  const [state, dispatch] = useReducer(reducer, mkState(props));

  return (
    <IntegrationContext.Provider value={{ state, dispatch }}>
      <div css={css('min-height: 65vh;')} className="position-relative">
        <NavHeader />
        <BodyShell />
      </div>
    </IntegrationContext.Provider>
  );
};
